import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    evaluacionesIse: [],
    evaluacionesIseExpediente: [],
  },

  getters: {
    getEvaluacionesIse: (state) => state.evaluacionesIseExpediente,

    getEvaluacionesIseAll: (state) => state.evaluacionesIse,
  },

  mutations: {
    SET_EVALUACIONES_ISE(state, evaluacionesIse) {
      state.evaluacionesIse = evaluacionesIse;
    },

    SET_EVALUACIONES_ISE_EXPEDIENTE(state, evaluacionesIseExpediente) {
      state.evaluacionesIseExpediente = evaluacionesIseExpediente;
    },
  },

  actions: {
    async fetchEvaluacionesIse({ commit }) {
      axios
        .get('PoliciaCuadrantes/C3/evaluacionesise')
        .then((response) => {
          commit('SET_EVALUACIONES_ISE', response.data.data);
        });
    },

    async fetchEvaluacionesIseByExpediente({ commit }, idExpediente) {
      await axios
        .get(`PoliciaCuadrantes/C3/expedientes/${idExpediente}/evaluacionesise`)
        .then((response) => {
          commit('SET_EVALUACIONES_ISE_EXPEDIENTE', response.data.data);
        });
    },

    async saveEvaluacionIse(context, evaluacionIse) {
      await axios
        .post(`PoliciaCuadrantes/C3/expedientes/${evaluacionIse.fk_idExpediente}/evaluacionesise`, evaluacionIse)
        .then(() => {
          context.dispatch(
            'derivaciones/updateEstatusDerivacion',
            {
              fk_idProgramacion: evaluacionIse.fk_idProgramacion,
              idDerivacion: evaluacionIse.fk_idDerivacion,
            },
            { root: true },
          );
        });
    },

    async updateEvaluacionIse(context, evaluacionIse) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/expedientes/${evaluacionIse.Derivacion.Programacion.fk_idExpediente}/evaluacionesise/${evaluacionIse.idIse}`,
          evaluacionIse,
        )
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Evaluación ISE editada.', {
            root: true,
          });
        });
    },

    async updateEstatusEvaluacionIse(context, evaluacionIse) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/expedientes/${
            evaluacionIse.Derivacion.Programacion.fk_idExpediente
          }/evaluacionesise/${
            evaluacionIse.idIse
          }/estatus`,
          {
            fk_idCatEstatusEvaluacion: evaluacionIse.fk_idCatEstatusEvaluacion,
          },
        )
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Estatus de evaluación ISE actualizado.', {
            root: true,
          });
        });
    },
  },
};
